exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-outline[data-v-1046f408]{border:2px solid #1396EC}@media screen and (min-width: 768px){.button-outline[data-v-1046f408]{border:3px solid #1396EC;min-width:250px}}.dark[data-v-1046f408]{color:#1396EC;border:3px solid #1396EC}.dark[data-v-1046f408]:hover,.dark[data-v-1046f408]:focus{color:#fff;background:#1396EC;border-color:#1396EC}.light[data-v-1046f408]{border-color:#fff;color:#fff}.light[data-v-1046f408]:hover,.light[data-v-1046f408]:focus{color:#1396EC;background:#fff;border-color:#fff}\n", ""]);

// exports
